import React from "react";
import "./Stepper.css";

const CheckIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden>
    <path
      d="M2.5 6.2L4.8 8.5L9.5 3.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Шаги мастера; к пройденным шагам можно вернуться кликом, пока мастер не завершён (locked) */
function Stepper({ steps, current, locked = false, onChange }) {
  return (
    <ol className="al-steps">
      {steps.map((step, index) => {
        const status =
          index < current || (locked && index === current)
            ? "done"
            : index === current
            ? "active"
            : "upcoming";
        const isClickable = !locked && index < current;

        return (
          <li key={step.id} className={`al-steps__item is-${status}`}>
            <button
              type="button"
              className="al-steps__button"
              disabled={!isClickable}
              aria-current={status === "active" ? "step" : undefined}
              onClick={() => onChange(index)}
            >
              <span className="al-steps__circle">
                {status === "done" ? <CheckIcon /> : index + 1}
              </span>
              <span className="al-steps__label">{step.label}</span>
            </button>
            {index < steps.length - 1 && <span className="al-steps__line" />}
          </li>
        );
      })}
    </ol>
  );
}

export default Stepper;
